import { useCallback, useContext, useEffect, useState } from 'react';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../../../shared/components';

import { StepThreeFormContext } from '../../../../contexts/StepThreeForm';

import { ValidateForm } from '../../../../../../../../../../../shared/utils';

import './index.css';
import { MasterContext } from '../../../../../../../../../../../shared/contexts';
import { QuotationInfoContext } from '../../../../../../../shared';
import { getExplanatoryTexts } from '../../../../../../../utils';
import { Typography } from 'antd';
import { COLORS } from '../../../../../../../../../../../config/themes/colors';

interface PlansSectionProps {
  duplicateId?: number;
  id: number;
}

export const PlansSection = ({ duplicateId, id }: PlansSectionProps) => {
  const validateForm = new ValidateForm();

  const { stepThreeForm, plansByActivityList } = useContext(StepThreeFormContext);

  const duplicatePlanIfExists = () => {
    if (duplicateId) {
      const duplicatePlan = stepThreeForm?.getFieldValue(
        `plan-tab-${duplicateId}`
      );
      stepThreeForm?.setFieldValue(`plan-tab-${id}`, duplicatePlan);
    }
  };

    const { globalPublicConfigs } = useContext(MasterContext);
    const { quotationInfo } = useContext(QuotationInfoContext);
    const [explanatoryText, setExplanatoryText] = useState<string>("");    

    const handleExplanatoryText = useCallback(() => {
      const text = getExplanatoryTexts(
        Number(quotationInfo?.branch),
        Number(quotationInfo?.article),
        Number(stepThreeForm?.getFieldValue(`plan-tab-${id}`)),
        globalPublicConfigs?.QUOTATION_EXPLANATORY_TEXTS
      );
      setExplanatoryText(text);
      stepThreeForm?.setFieldValue(`explanatory-text-tab-${id}`, text);
    }, [
      quotationInfo?.branch,
      quotationInfo?.article,
      stepThreeForm,
      globalPublicConfigs?.QUOTATION_EXPLANATORY_TEXTS,
      id,
    ]);

  useEffect(() => {
    duplicatePlanIfExists();
    handleExplanatoryText();
  }, [duplicateId, stepThreeForm, id, duplicatePlanIfExists, handleExplanatoryText]);

  return (
    <ContentSection level='h3' title='Planes'>
      <RowSize>
        <ColSize size={25}>
          <SelectForm
            formProps={{
              label: 'Lista de Planes:',
              name: `plan-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'lista de planes',
                rules: ['required'],
              }),
            }}
            selectProps={{ 
              options: plansByActivityList,
              onChange: handleExplanatoryText,
            }}
          />
        </ColSize>
      </RowSize>
      {!!explanatoryText && 
      <Typography.Text strong style={{ fontSize: 16, color: COLORS.neutrals[70] }} >
        {explanatoryText}
      </Typography.Text>
      }        
    </ContentSection>
  );
};
